import { render, staticRenderFns } from "./DialogEditDetail.vue?vue&type=template&id=5d240f4e&scoped=true"
import script from "./DialogEditDetail.vue?vue&type=script&lang=js"
export * from "./DialogEditDetail.vue?vue&type=script&lang=js"
import style0 from "./DialogEditDetail.vue?vue&type=style&index=0&id=5d240f4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d240f4e",
  null
  
)

export default component.exports